import React from 'react';
import PropTypes from 'prop-types';
import {PowerSupplyContext} from '../..';
import {useTranslation} from 'react-i18next';
import {Button} from '@learningblocks/storybook-components';

import './style.scss';

const TRANSLATION_KEY = 'Done.string';

export function DoneButton(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  const TEXT = t(TRANSLATION_KEY);

  const {completed} = React.useContext(PowerSupplyContext);

  const invalidFlag = completed ? '' : '--invalid';
  const className = ` mc_doneButton${invalidFlag} ${props.className}`;

  return (
    <Button className={className} onClick={completed && props.onClick}>
      {TEXT}
    </Button>
  );
}

DoneButton.propTypes = {
  /**
   * classname for component
   */
  className: PropTypes.string,
  /**
   * callback function trigger on click
   */
  onClick: PropTypes.func,
};
